import Link from "@mui/material/Link"
import { Link as RouterLink } from "react-router-dom"

import LegalPage, {
  OrderedList,
  SectionSubtitleTypography,
  SectionTitleTypography,
  TermTypography,
  UnorderedList,
} from "../../../common/components/LegalPage"
import { SETTINGS_TABS, createSettingsTabURL } from "../../customer/settings"

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy">
      <TermTypography>
        This website application and its related services (“Application”) are
        operated by OneBase, Inc either directly or through one of its
        contractors or affiliates (individually and collectively hereafter
        referred to as “OneBase”). The Application includes both the OneBase
        Website and individual websites for real estate agents and brokers
        (hereafter together referred to as the “Website”). When using the
        Website, your privacy on the Internet is of the utmost importance to us.
        At OneBase, we want to make your experience online both satisfying and
        safe. Because we gather certain types of information about our users, we
        feel you should fully understand the terms and conditions surrounding
        the capture and use of that information. This Privacy Policy discloses
        what information we gather and how we use it.
      </TermTypography>
      <SectionTitleTypography>
        Information collected and tracked by OneBase
      </SectionTitleTypography>
      <TermTypography>
        In general, when you visit our website, you remain anonymous. When you
        open an account on the Website or input your data into a web form, your
        Website activity may be tracked by the Application and may be viewed,
        accessed, and tracked by a real estate agent or broker connected to the
        Application you access (your “Agent” or “Broker“), and OneBase,
        including, without limitation, when you log on to the Website, what you
        view, and information that you save, submit, transmit, or post to or
        from the Website (collectively, “Website Activity”). An Agent or Broker
        may transmit your Website Activity to, and share such Activity with, its
        affiliated licensed real estate agents or contractors without your
        notice or permission, except for your Private Notes, and an Agent or
        Broker may reassign responsibility for collaborating with you through a
        Website account to an affiliate, without prior notice to you or your
        consent.
      </TermTypography>
      <SectionTitleTypography>
        OUR COMMUNICATIONS WITH YOU (TCPA Consent for United States Residents)
      </SectionTitleTypography>
      <TermTypography>
        <OrderedList>
          <li>
            <TermTypography>
              EXPRESS WRITTEN CONSENT. By using the OneBase Application and
              submitting your contact information, you are providing your
              express written consent to receive communications from OneBase,
              OneBase Application or Real Estate Professional Users, at the
              email address and telephone numbers you entered into your account
              registration or contact form, or that you later provide to us or
              enter into the OneBase Application, via live, automated or
              prerecorded email, text, or call.
            </TermTypography>
          </li>
          <li>
            <TermTypography>
              E-MAILS, TEXTS, AND CALLS. These communications may include
              OneBase Application updates, information about products and
              services, and telemarketing messages, through the use of email,
              landline phone, cellular phone, and text messages (including SMS
              and MMS).
            </TermTypography>
          </li>
          <li>
            <TermTypography>
              AUTOMATION. OneBase, OneBase Application or Real Estate
              Professional Users may contact you via live, automated or
              prerecorded email, text, or call. Your carrier’s standard rates
              and charges may apply.
            </TermTypography>
          </li>
          <li>
            <TermTypography>
              NO PURCHASE IS NECESSARY. Agreeing to these communications is not
              a condition of purchasing any property, goods, or services from
              us.
            </TermTypography>
          </li>
          <li>
            <TermTypography>
              REVOKING CONSENT AND OPTING OUT. You may revoke your consent to
              receive communications at any time by replying “stop” to any of
              our texts, or by any other reasonable means. We will make a
              commercially reasonable effort to comply with any communications
              from you opting out, but reply “stop” will automatically revoke
              your consent to further text communications, and we recommend that
              method. We may take up to 30 days to stop communications if you
              use a method other than the automatic reply “stop.” You consent to
              receive a final text message confirming your opt-out. You may
              revoke your consent to receive email communications by using the
              “unsubscribe” link in an email or by any other reasonable means.
              We will make a commercially reasonable effort to comply with any
              communications from you opting out of email, but “unsubscribe”
              will automatically revoke your consent to further email
              communications, and we recommend that method. We may take up to 30
              days to stop email communications if you use a method other than
              “unsubscribe”. The “unsubscribe” link will also permit you to stop
              text communications. Your consent here also serves as your express
              written consent to electronic communications from us in the past.
            </TermTypography>
          </li>
          <li>
            <TermTypography>
              You represent and warrant that you 1) are at least 18 years old;
              2) live in the United States (or Canada, in which case the
              Canadian consents below apply); 3) have not registered on a
              national or statewide Do Not Call list; 4) are the account holder
              for the email addresses and phone numbers you provided, or you
              have authorization from the account holder to give this consent,
              and 5) confirm that the email addresses and phone numbers you
              provided are accurate.
            </TermTypography>
          </li>
          <li>
            ADDITIONAL COMMUNICATIONS PROVISIONS (FOR RESIDENTS OF CANADA). In
            addition to the consent provided above in the Our Communications
            With You (United States) section, Canadian residents agree to the
            following provisions related to compliance with Canada's Anti-Spam
            Legislation (“CASL”), Canada's Personal Information Protection and
            Electronic Documents Act (“PIPEDA”) and Canadian provincial law
            including Alberta' Personal Information Protection Act (“PIPA”), and
            Quebec's Act Respecting the Protect of Personal Information in the
            Private Sector, 1) you agree to the provisions governing use and
            disclosure of personal information that are found in our Privacy
            Policy; 2) because the purpose of our communications include your
            interest in our services, our communication with you will continue
            until you revoke your consent or opt-out; and 3) your personal
            information may also be transmitted to, used in, and stored in the
            United States.
          </li>
        </OrderedList>
      </TermTypography>
      <SectionTitleTypography>
        Optional Voluntary Information
      </SectionTitleTypography>
      <TermTypography>
        There are occasions when we may ask you to voluntarily submit additional
        information about yourself, such as your name, address, telephone
        number, and e-mail address. We may also request your credit card number
        and expiration date. We may request this information to register you as
        an account holder, manage your account, be able to better understand
        your needs, adjust our website to your personal preferences, enable you
        to order products and services via the website, enable you to
        participate in any message boards, and send you e-mail and postal mail
        newsletters and announcements, and for other similar business purposes.
        We give you the opportunity to elect not to receive future materials
        from us.
      </TermTypography>
      <SectionTitleTypography>Usage Tracking</SectionTitleTypography>
      <TermTypography>
        We collect tracking information and monitor traffic patterns throughout
        this website; however, we do not correlate this information with data
        about individual users unless you are a registered account holder. We do
        break down overall usage statistics according to a user's domain name,
        browser type, and MIME type by reading this information from the browser
        string (information contained in every user's browser). This information
        allows us to better tailor our content to users' needs and to help our
        advertisers and sponsors better understand the demographics of our
        audience.
      </TermTypography>
      <SectionTitleTypography>
        Google User Data: Retention and Deletion
      </SectionTitleTypography>
      <TermTypography>
        OneBase uses Google OAuth to allow users to authenticate securely using
        their Google accounts. Upon successful authentication, we collect and
        store certain user data from Google to provide our services effectively.
      </TermTypography>
      <SectionSubtitleTypography>Data We Collect:</SectionSubtitleTypography>
      <TermTypography>
        When you sign in with Google, we may collect and store the following
        information:
      </TermTypography>
      <UnorderedList>
        <li>
          <TermTypography>
            Basic profile information (such as name and email address)
          </TermTypography>
        </li>
        <li>
          <TermTypography>
            Email messages from your connected Gmail account
          </TermTypography>
        </li>
      </UnorderedList>
      <TermTypography>
        This data is collected strictly to provide features within the OneBase
        platform, such as displaying, managing, or analyzing your
        communications.
      </TermTypography>
      <SectionSubtitleTypography>
        How We Store and Protect Your Data:
      </SectionSubtitleTypography>
      <TermTypography>
        All Google user data is stored securely in our database with
        industry-standard encryption and access controls. We do not share, sell,
        or distribute your data to third parties without your explicit consent,
        except as required by law.
      </TermTypography>
      <SectionSubtitleTypography>
        Retention of Google User Data:
      </SectionSubtitleTypography>
      <TermTypography>
        We retain your Google data for as long as your account remains active or
        as needed to provide you with our services. If your account becomes
        inactive or is deleted, we initiate a process to remove your data from
        our systems within <strong>30 days</strong>.
      </TermTypography>
      <SectionSubtitleTypography>
        Deletion of Google User Data:
      </SectionSubtitleTypography>
      <TermTypography>
        You can request the deletion of your Google user data at any time by
        contacting us directly at{" "}
        <Link href="mailto:support@onebasecrm.com">support@onebasecrm.com</Link>
        .
      </TermTypography>
      <TermTypography>
        Once a deletion request is received, we will permanently delete your
        associated Google data from our servers within <strong>30 days</strong>,
        unless retention is legally required.
      </TermTypography>
      <SectionSubtitleTypography>
        Revoking Google Access:
      </SectionSubtitleTypography>
      <TermTypography>
        You can also revoke OneBase's access to your Google account at any time
        via your{" "}
        <Link
          to={createSettingsTabURL(SETTINGS_TABS.configureEmail)}
          component={RouterLink}
        >
          email settings page
        </Link>{" "}
        .
      </TermTypography>
      <SectionTitleTypography>Other Data Collection</SectionTitleTypography>
      <TermTypography>
        We may collect data from or about you in other ways not specifically
        described in this policy. For example, you might contact us with a
        question. We maintain such data like other business records. All
        opinions, ideas, suggestions, and other feedback submitted through our
        website may be used by OneBase, without any restriction and free of
        charge, and nothing contained in this policy shall limit or otherwise
        affect this.
        <br />
        We may also collect non-personally identifiable information such as the
        type of internet browser you are using, the type of computer operating
        system you are using, and the domain name of the website from which you
        linked to our website or an advertisement.
        <br />
        Please note that OneBase will fully cooperate with any court order or
        other legal process and will provide your personal information to the
        extent required in any legal proceeding.
      </TermTypography>
      <SectionTitleTypography>
        Use of information and protection of your privacy
      </SectionTitleTypography>
      <TermTypography>
        As mentioned above, OneBase may use personal information about you and
        track your usage of our website to register you as an account holder,
        manage your account, be able to better understand your needs, adjust our
        website to your personal preferences, enable you to use the services
        provided by the website, order products, and services via the website,
        enable you to communicate with an Agent or Broker, and send you text,
        e-mail, and postal mail information, and for other similar business
        purposes. OneBase does not sell, share or otherwise disclose email
        addresses, phone numbers, or other personal information to any outside
        parties other than OneBase affiliates and contractors, and to other
        Agents or Brokers related to the performance of our services, without
        your permission unless such disclosure is necessary to comply with
        applicable law or valid legal process or to protect the personal safety
        of our users or the public.
        <br />
        We may use third-party contractors who can access our databases for the
        purpose of conducting repairs or upgrades to our computer system. We may
        also use third-party service providers and give access to your personal
        information as part of the services they provide to us. We hold all such
        third parties to the same privacy standards to which we hold ourselves.
        We require these third parties to use and disclose your personal
        information only as necessary to perform their services.
      </TermTypography>
      <SectionTitleTypography>
        No Mobile Information Sharing
      </SectionTitleTypography>
      <TermTypography>
        No mobile information will be shared with third parties/affiliates for
        marketing/promotional purposes.
      </TermTypography>
      <SectionTitleTypography>Children</SectionTitleTypography>
      <TermTypography>
        Consistent with the Federal Children's Online Privacy Protection Act
        (COPPA), OneBase will never knowingly request personally identifiable
        information from anyone under the age of 13. If we discover that a child
        under the age of 13 has provided us with any personally identifiable
        information, we will delete that information from our systems.
      </TermTypography>
      <SectionTitleTypography>Cookies</SectionTitleTypography>
      <TermTypography>
        OneBase may place text files called “cookies” in the browser files of
        your computer. The cookies themselves do not contain personal
        information, although they will enable us to relate your use of this
        website to information that you have specifically and knowingly
        provided. The only personal information cookies can contain is
        information you supply yourself. Cookies can't read data off your hard
        disk or read cookie files created by other sites. OneBase uses cookies
        to track user traffic patterns (as described above). We may also use
        cookies when you register for an account. In these situations, a cookie
        will store useful information that enables our website to remember you
        when you return to visit us.
        <br />
        You can refuse cookies by turning them off in your browser. If you've
        set your browser to warn you before accepting cookies, you will receive
        the warning message with each cookie. You do not need to have cookies
        turned on to use this site. However, you do need cookies to participate
        actively in the message boards and forums. Please refer to your browser
        instructions for information regarding erasing, blocking, and receiving
        warnings for cookies.
      </TermTypography>
      <SectionTitleTypography>Security</SectionTitleTypography>
      <TermTypography>
        OneBase operates secure data networks protected by industry-standard
        security protocols, such as (if and where appropriate) firewalls,
        encryption, and password protection systems. Our security and privacy
        policies are periodically reviewed and enhanced as necessary, and only
        authorized individuals have access to the information provided by our
        users.
      </TermTypography>
      <SectionTitleTypography>
        Unsubscribe / Opt-out Policy
      </SectionTitleTypography>
      <TermTypography>
        You may unsubscribe or opt-out of receiving electronic correspondence
        from us by either logging into your account to modify your preferences
        or following any instructions in such electronic correspondence on how
        to unsubscribe or opt out from that list. The foregoing does NOT opt you
        out of receiving e-mail correspondence about your account. If you have
        questions or complaints about our privacy practices, please reach out to
        us using the contact web form on our website.
      </TermTypography>
      <SectionTitleTypography>Links</SectionTitleTypography>
      <TermTypography>
        This website may contain links to other websites that are not under our
        control. OneBase is not responsible for the content or privacy practices
        of those sites, and we provide the links solely for the convenience and
        information of our visitors.
      </TermTypography>
      <SectionTitleTypography>Your consent</SectionTitleTypography>
      <TermTypography>
        By using this website, you consent to the collection and use of this
        information by OneBase and by Agents or Brokers. If we decide to change
        our Privacy Policy, we will post those changes on this page so you are
        always aware of what information we collect, how we use it, and under
        what circumstances we disclose it.
      </TermTypography>
      <SectionTitleTypography>Terms of Service</SectionTitleTypography>
      <TermTypography>
        BY ACCESSING OR USING THE WEBSITE, YOU AGREE TO BE BOUND BY THE TERMS OF
        SERVICE, INCLUDING THE PROVISION PROVIDING THAT ALL DISPUTES RELATING TO
        THE WEBSITE SHALL BE RESOLVED EXCLUSIVELY THROUGH ARBITRATION.
      </TermTypography>
      <SectionTitleTypography>Contact us</SectionTitleTypography>
      <TermTypography>
        If you have any additional questions or concerns about our Privacy
        Policy, please contact us: <br />
        OneBase, Inc
        <br />
        219 Dufferin St,
        <br />
        Toronto, ON M6K 3J1
      </TermTypography>
    </LegalPage>
  )
}
